// extracted by mini-css-extract-plugin
export default {"info":"delete-location-set_info__r7k6W","text":"delete-location-set_text__jO+JW","source":"delete-location-set_source__EL2xS","button":"delete-location-set_button__BvYpf"};